export const MONGO_DB_ID_LENGTH = 24;
